/**
 * Origem do clique num anúncio da Meta (Instagram/Facebook) no cardápio.
 *
 * O anúncio aponta para o cardápio com `?c=<código do link>` e, no campo
 * "parâmetros de URL" do Gerenciador, `nc_c={{campaign.id}}&nc_as={{adset.id}}
 * &nc_ad={{ad.id}}` — a Meta troca as chaves pelos ids em cada clique e ainda
 * acrescenta o `fbclid`. O `?c=` é tratado pelo smsRef (é ele que diz de qual
 * link/loja o clique veio); aqui fica a parte que diz QUAL anúncio.
 *
 * Guarda no localStorage com o mesmo prazo de 7 dias da atribuição, e vale o
 * ÚLTIMO clique. Vai no pedido como `origem_anuncio`; o servidor saneia e
 * grava junto da atribuição (api/v1/sms/tracking.py). Tudo é melhor esforço:
 * nada aqui pode atrapalhar o pedido.
 */
const CHAVE = "nucleo_origem_anuncio";
const PRAZO_MS = 7 * 24 * 60 * 60 * 1000;
const MAX_ID = 25;
const MAX_FBCLID = 500;

const idValido = (v) => typeof v === "string" && /^\d{1,25}$/.test(v) && v.length <= MAX_ID;

export function capturarOrigemAnuncio() {
  try {
    const q = new URLSearchParams(window.location.search);
    const campaign_id = q.get("nc_c") || "";
    const adset_id = q.get("nc_as") || "";
    const ad_id = q.get("nc_ad") || "";
    const fbclid = (q.get("fbclid") || "").slice(0, MAX_FBCLID);
    const origem = {
      campaign_id: idValido(campaign_id) ? campaign_id : null,
      adset_id: idValido(adset_id) ? adset_id : null,
      ad_id: idValido(ad_id) ? ad_id : null,
      fbclid: fbclid || null,
    };
    // Só vale a pena guardar se houver pelo menos um sinal de anúncio.
    if (!origem.campaign_id && !origem.ad_id && !origem.fbclid) return;
    localStorage.setItem(CHAVE, JSON.stringify({
      ...origem,
      clicado_em: new Date().toISOString(),
      expira: Date.now() + PRAZO_MS,
    }));
  } catch { /* storage bloqueado: rastreio vira melhor esforço */ }
}

export function obterOrigemAnuncio() {
  try {
    const bruto = localStorage.getItem(CHAVE);
    if (!bruto) return undefined;
    const dados = JSON.parse(bruto);
    if (!dados || Date.now() > Number(dados.expira || 0)) {
      localStorage.removeItem(CHAVE);
      return undefined;
    }
    const { campaign_id, adset_id, ad_id, fbclid, clicado_em } = dados;
    return { campaign_id, adset_id, ad_id, fbclid, clicado_em };
  } catch {
    return undefined;
  }
}
